import { useRequest, useUpdateEffect } from "ahooks";
import { Modal, Spin } from "antd";
import { isNil } from "ramda";
import { FC, useState } from "react";

import DeptCourseContent from "@/pages/course-detail/components/dept-course-content";
import { getDeptTutorialsDetailByCreationApi } from "@/services/api";
import { IDeptTutorialDetail } from "@/types/dept-tutorials";

export interface IPreviewTutorialProps {
  open: boolean;
  tutorialId?: string;
  data?: IDeptTutorialDetail;
  onClose: () => void;
  index?: number;
}
export const PreviewTutorialModal: FC<IPreviewTutorialProps> = (props) => {
  const { open, tutorialId, index, data, onClose } = props;

  const [deptTutorialsDetailData, setDeptTutorialsDetailData] =
    useState<IDeptTutorialDetail>();

  const getDeptTutorialsDetailByCreationRequest = useRequest(
    getDeptTutorialsDetailByCreationApi,
    {
      manual: true,
      onSuccess: (result) => {
        setDeptTutorialsDetailData(result.data);
        // 不是视频类型，进页面就开始计算时间
      },
    }
  );

  // 添加一个空函数来满足类型要求，但不执行任何操作
  const handleEmptyFunction = () => {
    // 空实现 - 仅用于满足类型要求
  };

  useUpdateEffect(() => {
    if (open) {
      if (!isNil(data)) {
        setDeptTutorialsDetailData(data);

        return;
      }
      if (tutorialId) {
        getDeptTutorialsDetailByCreationRequest.run(tutorialId);

        return;
      }
    }
  }, [open, data]);

  return (
    <>
      <Modal
        width={"max-content"}
        open={open}
        maskClosable={false}
        keyboard={false}
        footer={null}
        closable={true}
        bodyStyle={{
          display: "flex",
          minWidth: "500px",
          minHeight: "500px",
          justifyContent: "center",
          alignItems: "center",
        }}
        destroyOnClose={true}
        onCancel={() => {
          setDeptTutorialsDetailData(undefined);
          onClose();
        }}
      >
        <div className="pt-3">
          {getDeptTutorialsDetailByCreationRequest.loading && <Spin />}
          {isNil(deptTutorialsDetailData) || (
            <DeptCourseContent
              gotoDeptCourse={handleEmptyFunction}
              getStartTime={handleEmptyFunction}
              reportTutorialsLearningRecord={handleEmptyFunction}
              currentCourse={deptTutorialsDetailData.title}
              type={deptTutorialsDetailData.type}
              tutorial={deptTutorialsDetailData}
              isPreview={true}
              index={index}
            />
          )}
        </div>
      </Modal>
    </>
  );
};
